import { useEffect } from "react";

import {
  useGetSettings,
  useIsSettingsContextMutating,
  useUpdateSettingsContext,
} from "@/entities/settings";
import {
  useOrganizationContext,
  useOrganizationContextInvalid,
} from "@/modules/organization/organization-context";

export const useOrganizationContextSync = () => {
  const { contextSlug } = useOrganizationContext();
  const { isInvalid, isLoading } = useOrganizationContextInvalid();

  const { settings, isFetching } = useGetSettings();
  const { mutate, isPending } = useUpdateSettingsContext();
  const isMutating = useIsSettingsContextMutating();

  const settingsValue = settings?.context;
  const isNotDefined = !contextSlug || !settingsValue || isInvalid;
  const isProcessing = isFetching || isLoading || isPending || isMutating;

  // Save context value in user settings when url param `context` update.
  // Do not update when same mutation is already running or data is fetching.
  useEffect(() => {
    if (isProcessing || isNotDefined || contextSlug === settingsValue) return;
    mutate(contextSlug);
  }, [contextSlug, settingsValue, isNotDefined, isProcessing, mutate]);
};
